import { render, staticRenderFns } from "./Report_NewCase.vue?vue&type=template&id=2b440388"
import script from "./Report_NewCase.vue?vue&type=script&lang=js"
export * from "./Report_NewCase.vue?vue&type=script&lang=js"
import style0 from "./Report_NewCase.vue?vue&type=style&index=0&id=2b440388&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports